"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarSchema = exports.RenderedBarLinkSchema = exports.BarLinkSchema = void 0;
const zod_1 = require("zod");
const templating_1 = require("../templating");
/*
 * This defines the links that are displayed in the bar
 */
exports.BarLinkSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: templating_1.StringLike,
    iconURL: templating_1.StringLike.optional(),
    url: templating_1.StringLike,
});
exports.RenderedBarLinkSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    iconURL: zod_1.z.string().optional(),
    url: zod_1.z.string(),
});
/**
 * This defines how the bar is configures to display links
 */
exports.BarSchema = zod_1.z.object({
    links: zod_1.z.array(exports.BarLinkSchema),
});
